import { createColumnHelper } from '@tanstack/react-table'

import { dataGridFeatures, DataGridFeatures } from '../../../../design-system/DataGrid'
import { IUserFilteredInfo } from '../../../../types/users'

export const usersTableFeatures = dataGridFeatures

export type UsersTableFeatures = DataGridFeatures

export const columnHelper = createColumnHelper<UsersTableFeatures, IUserFilteredInfo>()
